// extracted by mini-css-extract-plugin
export var arrow = "_52-4";
export var arrowButton = "_52-6";
export var columnResizer = "_52-a";
export var columnResizerActive = "_52-b";
export var columnResizerIndicator = "_52-c";
export var columnResizerIndicatorActive = "_52-d";
export var headerCell = "_52-0";
export var help = "_52-3";
export var hoverArrow = "_52-5";
export var icon = "_52-2";
export var iconButton = "_52-9";
export var iconWrapper = "_52-8";
export var noBorder = "_52-e";
export var sortableHeaderCell = "_52-1";
export var textButton = "_52-7";